var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoEspnRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 18,
    viewBox: "0 0 73 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_3024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.291 0H23.779C21.0629 0 19.2663 1.42855 19.0124 3.56785C18.9194 4.35616 18.8291 5.05139 18.8291 5.05139H54.1564C54.1564 5.05139 54.2227 4.52961 54.2735 4.11219C54.54 1.95597 53.6234 0 50.291 0Z",
    fill: "#EF4135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.922 6.97656C53.922 6.97656 53.8444 7.68167 53.7358 8.46575C53.5243 10.0071 52.3764 11.1536 50.2427 11.1536H42.7206L41.8745 17.9988H35.8867L37.2405 6.97656H53.922Z",
    fill: "#EF4135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2308 0L17.6132 5.05139H1.58887L2.20936 0H18.2308Z",
    fill: "#EF4135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35522 6.97656H17.3753L16.862 11.1536H6.8325L6.57866 13.2168H16.6109L16.0215 17.9988H0L1.35522 6.97656Z",
    fill: "#EF4135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.997 0H69.0641C71.13 0 73.2693 0.958947 72.8463 4.27437C72.7701 4.86948 72.7476 5.05139 72.7476 5.05139H55.3779L55.997 0Z",
    fill: "#EF4135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1376 6.9751L61.1324 6.97792L59.7772 17.9959L53.7852 17.9988L55.1376 6.9751Z",
    fill: "#EF4135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5242 6.9751L72.5148 6.97792L71.161 17.9959L65.1689 17.9988L66.5242 6.9751Z",
    fill: "#EF4135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7493 6.979H18.5877C18.1478 9.85584 19.589 11.1561 21.6282 11.1561H29.7355L29.4831 13.222H17.822L17.2354 18.0041C17.2354 18.0041 29.9273 18.0041 30.4448 18.0041C30.8679 17.973 33.8392 17.8927 34.8489 15.4657C35.1775 14.676 35.4666 11.8499 35.5541 11.2562C36.0208 7.80821 33.6348 6.98605 31.7549 6.98605",
    fill: "#EF4135"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_3024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.8997,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEspnRed);
export default __webpack_public_path__ + "static/media/logo-espn-red.8127be213c8006e4cdc20581df8c972e.svg";
export { ForwardRef as ReactComponent };